export function toCountrySlug(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function matchCountryBySlug(countries, countrySlug) {
  const raw = String(countrySlug || "").trim();
  if (!raw || !Array.isArray(countries)) return null;

  const byId = countries.find((c) => String(c?.countryId) === raw);
  if (byId) return byId;

  const slug = toCountrySlug(raw);
  if (!slug) return null;

  return (
    countries.find((c) => toCountrySlug(c?.country) === slug) ||
    countries.find((c) => String(c?.country || "").toLowerCase() === raw.toLowerCase()) ||
    null
  );
}
